import React from "react";
import ProductGallery from "web/react/components/product-gallery/product-gallery";

interface PDPGalleryProps {
    product: Product;
    features: { [key: string]: any };
    relatedProducts?: ProductCard[];
    hasRelatedProductsSidebar: boolean;
    variant?: "oos-carousel";
    analyticsAction?: string;
}

function PDPGallery({
    features,
    product,
    relatedProducts,
    hasRelatedProductsSidebar,
    analyticsAction,
    variant,
}: PDPGalleryProps): React.ReactElement {
    let isSwipeOnRedirect = features?.pmt_221_swipe_redirect && product?.images.length >= 3;

    return (
        <ProductGallery
            analyticsAction={analyticsAction}
            relatedProducts={relatedProducts}
            images={product.images}
            currentLinkId={product.link_ids ? product.link_ids[0] : undefined}
            swipeRedirect={isSwipeOnRedirect}
            hasRelatedProductsSidebar={hasRelatedProductsSidebar}
            variant={variant}
        />
    );
}

export default PDPGallery;
